import { render, staticRenderFns } from "./checkbox-form.vue?vue&type=template&id=0d17ff66&"
import script from "./checkbox-form.vue?vue&type=script&lang=js&"
export * from "./checkbox-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports